<template>
  <div class="app-container">
    <div class="flex h-30 align-center">
      <div class="bg-ff flex flex-1 h-30 align-center plr-10 border-ra">
        <div class="flex align-center mr-20 cursor" v-for="(item, index) in tab" :key="index" @click="switchTab(index + 1, item)">
          <div class="mr-5" :class="index + 1 === tabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
          <div class="font-bold" :class="index + 1 === tabIndex ? 'font-16-f5971d' : 'font-16-30313a'">{{item.name}}</div>
        </div>
        <div class="flex flex-1 justify-end">
          <div class="flex  align-center border-l-f3f4f7 font-12-30313a cursor" @click="toFiltrate"><img src="/static/images/shaixuan.png" class="icon-14 ml-10 mr-5" alt="">筛选</div>
        </div>
      </div>
      <div class="flex ml-10">
        <div class="flex  align-center " v-if="cusType.timeName">
          <el-date-picker
            v-model="startTime"
            type="date"
            :placeholder="cusType.timeName + '开始时间'"
            value-format="yyyy-MM-dd">
          </el-date-picker>
          <span class="font-12-b9b9b9" style="width: 24px;border: 1px solid #e2e2e2;height: 30px; line-height: 30px;">至</span>
          <el-date-picker
            v-model="endTime"
            type="date"
            :placeholder="cusType.timeName + '结束时间'"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </div>
        <div class="flex ml-10">
          <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
            <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
            <el-input type="text" placeholder="输入客户名字" v-model="inputValue" @keyup.enter.native="searchBtn" clearable></el-input>
          </div>
          <button class="btn-30-bg-82b925" @click="searchBtn">搜索</button>
        </div>
      </div>
    </div>
    <!--<div>{{filterStr}}</div>-->
    <div class="flex mt-10 flex-wrap border-b-e2 mt-10 align-center" v-if="filterStr">
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[0].list.length>0">客户类型：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[0].list.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[0].list" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[1].list.length>0">客户来源：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[1].list.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[1].list" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[2].list.length>0">客户级别：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[2].list.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[2].list" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[3].list.length>0">房屋类型：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[3].list.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[3].list" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[4].list.length>0">户型：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[4].list.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[4].list" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[5].list.length>0">所在方位：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[5].list.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[5].list" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a  mr-10 pb-10" v-if="filterStr[6].valueStart || filterStr[6].valueEnd">建筑面积：
        <span class="font-12-85">{{filterStr[6].valueStart}}m<sup>2</sup>-{{filterStr[6].valueEnd}}m<sup>2</sup></span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[9].list1.length>0">业务部：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[9].list1.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[9].list1" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[10].list1.length>0">设计部：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[10].list1.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[10].list1" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[11].list1.length>0">客服部：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[11].list1.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[11].list1" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[12].list1.length>0">项目经理部：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[12].list1.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[12].list1" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[13].list1.length>0">核算部：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[13].list1.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[13].list1" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[14].list1.length>0">工程部：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[14].list1.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[14].list1" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[15].list1.length>0">业务员：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[15].list1.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[15].list1" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[16].list1.length>0">设计师：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[16].list1.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[16].list1" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[17].list1.length>0">客户经理：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[17].list1.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[17].list1" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[18].list1.length>0">核算员：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[18].list1.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[18].list1" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[19].list1.length>0">项目经理：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[19].list1.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[19].list1" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[20].list1.length>0">工程监理：
        <span class="font-12-85 plr-10" :class="index+1 === filterStr[20].list1.length ? '' : 'border-r-e2'" v-for="(item,index) in filterStr[20].list1" :key="index">{{item}}</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[7].valueStart || filterStr[7].valueEnd">预算金额：
        <span class="font-12-85">{{filterStr[7].valueStart}}元-{{filterStr[7].valueEnd}}元</span>
      </div>
      <div class="font-12-30313a mr-10 pb-10" v-if="filterStr[8].valueStart || filterStr[8].valueEnd">计算金额：
        <span class="font-12-85">{{filterStr[8].valueStart}}元-{{filterStr[8].valueEnd}}元</span>
      </div>
      <div class="btn-16-bd-ff5555 mb-10" style="margin-top: 3px" @click="cleanOption" v-if="filterStr"><i class="el-icon-close mr-5"></i>清空所有条件</div>
    </div>
    <div class="mtb-10 flex flex-wrap">
      <div class="flex align-center mr-5 mb-5" @click="onOperate(item)" :class="index === Index ? 'btn-24-bg-f5971d' : 'btn-24-bg-ff' " @mouseenter="enter(index)" @mouseleave="leave(index)" v-for="(item, index) in showBtn" :key="index">
        <img :src="index === Index ? item.iconActive : item.icon" class="icon-14 mr-5" alt="">
        <div>{{item.name}}</div>
      </div>
      <div class="flex align-center mr-5 mb-5 btn-24-bg-ff" v-if="importData === 1">
        <img src="/static/images/daoru.png" class="icon-14 mr-5" alt="">
        <el-upload
          multiple
          name="file"
          :httpRequest="httpRequestImport"
          :action="upImport"
          :show-file-list="false">
          <div style="margin: 10px auto 10px auto">导入客户</div>
        </el-upload>
      </div>
    </div>
    <div class="flex-1 h-0">
      <erp-table ref="erpTable" :table-data="tableData" :customs="[{field: 'telephone', visible: showTel}]"  :loading="loading" @on-detail="onDetail" :column-data="columnData" @on-manage="onManage" @on-message="onMessage"></erp-table>
    </div>
    <div style="margin-top: 10px;">
      <Pagination :pageSize="pageSize" v-model="pageNo" :pageTotal="pageTotal" :total="total" @on-jump="jump"></Pagination>
    </div>
    <Detail v-if="detailShow" :process-key="tab[tabIndex - 1].nickName" :detail="detailList"></Detail>
    <Filtrate ref="filtrate" :filter-list="filterList" :filtrateVisible="filtrateVisible"></Filtrate>
    <el-dialog :modal-append-to-body="false" :close-on-click-modal="false" :append-to-body="false" width="526px" title="录入储备客户" :visible.sync="isAdding" @closed="onCloseAdding">
      <div class="plr-20" style="height: 450px">
        <div style="padding: 10px 0;" class="flex align-center font-12-ff5555">
          <i class="el-icon-warning mr-5"></i>
          提示：标有 * 的为必填项！
        </div>
        <div class="flex align-center justify-space-between mb-10">
          <div class="flex align-center p-relative">
            <div class="require-tip">*</div>
            <div class="font-12-30313a mr-5">客户姓名：</div>
            <el-input style="width: 161px" v-model="customerInfo.name" placeholder="请输入"></el-input>
          </div>
          <div class="flex align-center p-relative">
            <div class="font-12-30313a mr-5 flex align-center"><div class="text-justify" style="width: 48px; height: 16px">性别</div>：</div>
            <el-select style="width: 161px" v-model="customerInfo.gender" placeholder="请选择">
              <el-option
                v-for="item in genderOption"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex align-center justify-space-between mb-10">
          <div class="flex align-center p-relative">
            <div class="require-tip">*</div>
            <div class="font-12-30313a mr-5">联系电话：</div>
            <el-input style="width: 161px" type="tel" v-model="customerInfo.telephone" placeholder="请输入"></el-input>
          </div>
          <div class="flex align-center p-relative">
            <div class="font-12-30313a mr-5">备用电话：</div>
            <el-input style="width: 161px" type="tel" v-model="customerInfo.spareTelephone" placeholder="请输入"></el-input>
          </div>
        </div>
        <div class="flex align-center justify-space-between mb-10">
          <div class="flex align-center p-relative">
            <div class="font-12-30313a mr-5 flex align-center"><div class="text-justify" style="width: 48px; height: 16px">年龄</div>：</div>
            <el-input style="width: 161px" v-model="customerInfo.age" placeholder="请输入"></el-input>
          </div>
          <div class="flex align-center p-relative">
            <div class="font-12-30313a mr-5">客户类型：</div>
            <el-select style="width: 161px" v-model="customerInfo.customerType" placeholder="请选择">
              <el-option
                v-for="item in filterList.customerType"
                :key="item.id"
                :label="item.text"
                :value="item.text">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="flex align-center mb-10 p-relative">
          <div class="require-tip">*</div>
          <div class="font-12-30313a mr-5">所在方位：</div>
          <el-select class="flex-1" v-model="customerInfo.location" placeholder="请选择">
            <el-option
              v-for="item in filterList.location"
              :key="item.id"
              :value="item.text">
            </el-option>
          </el-select>
        </div>
        <div class="flex align-center mb-10 p-relative">
          <div class="require-tip">*</div>
          <div class="font-12-30313a mr-5">楼盘小区：</div>
          <el-input class="flex-1" v-model="customerInfo.residentialDistrict" placeholder="请输入"></el-input>
        </div>
        <div class="flex align-center mb-10 p-relative">
          <div class="font-12-30313a mr-5">详细地址：</div>
          <div class="flex flex-1 align-center">
            <el-input placeholder="0" type="number" class="flex-1 border-radius-right-0" v-model="customerInfo.addressStage"></el-input>
            <div class="unit">期</div>
            <el-input placeholder="0" type="number" class="flex-1 border-radius-left-0 border-radius-right-0" v-model="customerInfo.addressBlock"></el-input>
            <div class="unit">幢</div>
            <el-input placeholder="0" type="number" class="flex-1 border-radius-left-0 border-radius-right-0" v-model="customerInfo.addressUnit"></el-input>
            <div class="unit">单元</div>
            <el-input placeholder="0" type="number" class="flex-1 border-radius-left-0 border-radius-right-0" v-model="customerInfo.addressOffice"></el-input>
            <div class="unit">楼</div>
            <el-input placeholder="0" type="number" class="flex-1 border-radius-left-0 border-radius-right-0" v-model="customerInfo.addressNumber"></el-input>
            <div class="unit" style="border-right: 1px solid #e2e2e2; border-top-right-radius: 3px; border-bottom-right-radius: 3px;">号</div>
          </div>
        </div>
        <div class="flex align-center mb-10">
          <div class="font-12-30313a mr-5">客户来源：</div>
          <el-select class="flex-1" v-model="customerInfo.customerSource" placeholder="请选择">
            <el-option
              v-for="item in filterList.customerSource"
              :key="item.id"
              :label="item.text"
              :value="item.text">
            </el-option>
          </el-select>
        </div>
        <div class="flex mb-10">
          <div class="font-12-30313a mr-5">来源备注：</div>
          <el-input :row="4" type="textarea" class="flex-1" v-model="customerInfo.sourceRemark"></el-input>
        </div>
        <div class="flex align-center justify-space-between mb-10">
          <div class="flex align-center p-relative">
            <div class="font-12-30313a mr-5">预计上门：</div>
            <el-date-picker style="width: 161px" class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="customerInfo.estimateTime"></el-date-picker>
          </div>
          <div class="flex align-center p-relative">
            <div class="font-12-30313a mr-5">交房时间：</div>
            <el-date-picker style="width: 161px" class="flex-1" type="date" placeholder="选择日期" format="yyyy.MM.dd " :clearable="false" v-model="customerInfo.deliveryTime"></el-date-picker>
          </div>
        </div>
      </div>
      <div slot="footer">
        <!--<div class="btn-30-border-85 mr-10" @click="onCloseAdding">取消</div>-->
        <div class="btn-30-bg-f5971d-s" @click="submitAdding">保存</div>
      </div>
    </el-dialog>
    <el-dialog :modal-append-to-body="false" :append-to-body="false" width="426px" title="提示" :visible.sync="isWarningShow">
      <div style="padding: 40px" class="flex-column align-center">
        <img src="/static/images/tip.png" style="width: 50px; margin-bottom: 20px;" alt="">
        <div class="font-12-30313a">请注意：<span style="color: #ff5555">客户</span></div>
        <div v-for="(item, index) in warningArr" :key="index">
          <div class="font-12-ff5555">
            {{item.customerNumber}}  {{item.name}}  {{item.telephone}} {{item.detailedAddress}}
          </div>
          <div class="font-12-30313a">
            已被 <span style="color: #ff5555">业务员 {{item.customerAssign.salesmanName}}</span> 确认提交上门了
          </div>
        </div>
        <div class="font-12-30313a">此提醒便于您决策是否还需继续跟踪这个客户！</div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="isWarningShow = false">我知道了</div>
      </div>
    </el-dialog>
    <el-dialog class="my-dialog" :modal-append-to-body="false" :append-to-body="false" width="529" :title="currentOperate.name" :visible.sync="isEmployeeShow">
      <div class="flex" style="height: 500px;">
        <div class="flex-1 border-r-e2 h-100 flex-column bg-ff dialog-half">
          <div class="dialog-left-top">
            部门
          </div>
          <el-scrollbar class="flex-1 hide-x">
            <div v-for="(item, index) in deptList" class="dialog-menu-item" :class="{'current': item.id === currentDept.id}" :key="index" @click="onClickDept(item, index)">
              <div class="flex-1 flex align-center">
                <span class="flex-1">{{item.name}}</span>
              </div>
              <img :src="item.id === currentDept.id ? '/static/images/xuanzhong.png' : '/static/images/weixuan.png'" class="icon-16" alt="">
            </div>
          </el-scrollbar>
        </div>
        <div class="flex-1 border-r-e2 h-100 flex-column dialog-half bg-f3f4f7">
          <div class="dialog-left-top">
            相关人员
          </div>
          <el-scrollbar class="flex-1 hide-x">
            <div v-for="(item, index) in employeeList" class="dialog-menu-item" :class="{'active' : item.id === currentEmp.id}" :key="index" @click="onClickEmployee(item, index)">
              <div class="flex-1 flex align-center">
                <span class="flex-1">{{item.name}}</span>
              </div>
              <img :src="item.id === currentEmp.id ? '/static/images/xuanzhong.png' : '/static/images/weixuan.png'" class="icon-16" alt="">
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="isEmployeeShow = false">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="onSubmitEmployee">保存</div>
      </div>
    </el-dialog>
    <el-dialog :show-close="false" width="725px" title="客户消息" :visible.sync="messagehow">
      <div style="padding: 20px" class="p-relative">
        <div class="flex-1 flex justify-end mb-20 p-absolute" style="top:-40px; right:20px">
          <div class="btn-30-bg-f5971d cursor" style="width:80px;" @click="onHistory">历史消息</div>
        </div>
        <el-form ref="form" :model="form" class="">
          <el-form-item>
            <div class="flex">
              <div class="font-12-30313a">消息内容：</div>
              <el-input class="flex-1 font-12-30313a" type="textarea" placeholder="请输入内容" v-model="form.content" rows="6" resize="none"></el-input>
            </div>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="messagehow = false">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="onSubmitMessage">发送</div>
      </div>
    </el-dialog>
    <el-dialog class="my-dialog" :modal-append-to-body="false" :append-to-body="false" width="529" title="选择发送人" :visible.sync="isSendShow">
      <div class="flex" style="height: 500px;">
        <div class="flex-1 border-r-e2 h-100 flex-column bg-ff dialog-half">
          <div class="dialog-left-top">
            部门
          </div>
          <cate-menu :menu-data="comDeptList" :not-operate="true" @on-choose="onCheckDept" :choose-id="currentSend.id"></cate-menu>
          <!-- <el-scrollbar class="flex-1 p-10"> -->
            <!-- <template v-for="(item, index) in comDeptList">
              <normal-menu :menu-data="item" :index="index" :key="index" @on-checked="onCheckDept"></normal-menu>
            </template> -->
          <!-- </el-scrollbar> -->
        </div>
        <div class="flex-1 border-r-e2 h-100 flex-column dialog-half bg-f3f4f7">
          <div class="dialog-left-top">
            相关人员
          </div>
          <el-scrollbar class="flex-1 hide-x">
            <div v-for="(item, index) in sendList" class="dialog-menu-item" :class="{'active' : newSendList.indexOf(item.id)>-1}" :key="index" @click="onChooseSend(item, index)">
              <div class="flex-1 flex align-center">
                <span class="flex-1">{{item.name}}</span>
              </div>
              <img :src="newSendList.indexOf(item.id)>-1 ? '/static/images/xuanzhong.png' : '/static/images/weixuan.png'" class="icon-16" alt="">
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div slot="footer">
        <div class="btn-30-border-85 mr-10" @click="isSendShow = false">取消</div>
        <div class="btn-30-bg-f5971d-s" @click="onSubmitSend">保存</div>
      </div>
    </el-dialog>
    <el-dialog
      title="历史记录"
      :visible.sync="historyShow"
      width="1200px">
      <div class="p-20 bg-f3f4f7" style="height: 600px;">
         <el-scrollbar class="h-100 hide-x">
            <div class="flex align-center mb-20 p-20 bg-ff" v-for="(item, index) in messageList" :key="index">
              <div class="flex-1 text-left mr-40">
                <div class="font-12-85">消息内容</div>
                <div class="font-12-30313a">{{item.content}}</div>
              </div>
              <div class="mr-40 text-left">
                <div class="font-12-85">创建人</div>
                <div class="font-12-30313a">{{item.remindName}}</div>
              </div>
              <div class="text-left">
                <div class="font-12-85">创建时间</div>
                <div class="font-12-30313a">{{Utils.formatTime(item.remindTime)}}</div>
              </div>
            </div>
          </el-scrollbar>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Filtrate from './Filtrate'
import ErpTable from '../../../components/ErpTable'
import Pagination from '../../../components/Pagination'
import NormalMenu from '../../../components/NormalMenu'
import CateMenu from '../../../components/CateMenu'
import Detail from './Detail'
export default {
  name: 'item',
  components: {ErpTable, Pagination, Detail, Filtrate, NormalMenu, CateMenu},
  props: ['columnData', 'routeName', 'menuName', 'titleName', 'parent', 'tab', 'isActivated', 'importData'],
  watch: {
    isActivated (newVal, oldVal) {
      this.isItemActivated = newVal
    },
    inputValue (val) {
      if (val === '') {
        this.getData()
      }
    }
  },
  data () {
    return {
      upImport: `${this.$store.state.API_URL_9010}/customer/import`,
      cusType: {},
      tabIndex: 1,
      filtrateVisible: false,
      isItemActivated: false,
      filterList: {},
      deptList: [],
      startTime: '',
      endTime: '',
      inputValue: '',
      page: 1,
      limit: 25,
      pageSize: 25, // 总页数
      pageNo: 1, // 当前页数
      pageTotal: 10, // 当前页条数
      total: 100, // 总条数
      tableData: [],
      loading: true,
      detailShow: false,
      isEmployeeShow: false,
      Index: -1,
      definedTemplate: '',
      isDetailShow: false,
      choseData: '',
      filterStr: null,
      detailList: {},
      showTel: false,
      customerPermission: [],
      genderOption: [{
        name: '男',
        value: 1
      }, {
        name: '女',
        value: 2
      }],
      btnList: [
        {
          name: '录入储备客户',
          label: 'addCustomer',
          icon: '/static/images/customer/chubeikehu.png',
          iconActive: '/static/images/customer/chubeikehu-bai.png',
          status: 0 // 0 指派， 1 流程跳转
        }, {
          name: '提交上门预报',
          label: 'submitDoorForecast',
          icon: '/static/images/customer/shangmenyubao.png',
          iconActive: '/static/images/customer/shangmenyubao-bai.png'
        }, {
          name: '提交上门客户',
          label: 'submitDoorCustomer',
          icon: '/static/images/customer/shangmenkehu.png',
          iconActive: '/static/images/customer/shangmenkehu-bai.png'
        }, {
          name: '提交预算审核',
          label: 'submitBudgetExamine',
          icon: '/static/images/customer/shangmenkehu.png',
          iconActive: '/static/images/customer/shangmenkehu-bai.png'
        }, {
          name: '提交概算合同',
          label: 'submitBudgetContract',
          icon: '/static/images/customer/shangmenkehu.png',
          iconActive: '/static/images/customer/shangmenkehu-bai.png'
        }, {
          name: '提交施工合同',
          label: 'submitConstructionContract',
          icon: '/static/images/customer/shangmenkehu.png',
          iconActive: '/static/images/customer/shangmenkehu-bai.png'
        }, {
          name: '提交工程管理',
          label: 'submitProjectManager',
          icon: '/static/images/customer/shangmenkehu.png',
          iconActive: '/static/images/customer/shangmenkehu-bai.png'
        }, {
          name: '提交设计师',
          label: 'submitDesigner',
          icon: '/static/images/customer/shangmenkehu.png',
          iconActive: '/static/images/customer/shangmenkehu-bai.png'
        }, {
          name: '提交客户经理',
          label: 'submitCm',
          icon: '/static/images/customer/shangmenkehu.png',
          iconActive: '/static/images/customer/shangmenkehu-bai.png'
        }, {
          name: '提交预算员',
          label: 'submitBe',
          icon: '/static/images/customer/shangmenkehu.png',
          iconActive: '/static/images/customer/shangmenkehu-bai.png'
        }, {
          name: '提交项目经理',
          label: 'submitPm',
          icon: '/static/images/customer/shangmenkehu.png',
          iconActive: '/static/images/customer/shangmenkehu-bai.png'
        }, {
          name: '提交工程监理',
          label: 'submitSu',
          icon: '/static/images/customer/shangmenkehu.png',
          iconActive: '/static/images/customer/shangmenkehu-bai.png'
        }, {
          name: '提交售后服务',
          label: 'submitAs',
          icon: '/static/images/customer/shangmenkehu.png',
          iconActive: '/static/images/customer/shangmenkehu-bai.png'
        }, {
          name: '提交飞单管理',
          label: 'submitFail',
          icon: '/static/images/customer/feidanyubao.png',
          iconActive: '/static/images/customer/feidanyubao-bai.png'
        }, {
          name: '提交业务员',
          label: 'submitSalesman',
          icon: '/static/images/customer/jiazhuangguwen.png',
          iconActive: '/static/images/customer/jiazhuangguwen-bai.png'
        }, {
          name: '核算同意开工',
          label: 'agreeStartWork',
          icon: '/static/images/customer/shangmenyubao.png',
          iconActive: '/static/images/customer/shangmenyubao-bai.png'
        }, {
          name: '提交竣工客户',
          label: 'submitProjectCompleted',
          icon: '/static/images/customer/shangmenkehu.png',
          iconActive: '/static/images/customer/shangmenkehu-bai.png',
          submitProject: 1
        }
      ],
      showBtn: [],
      isAdding: false,
      customerInfo: {},
      currentOperate: '',
      isWarningShow: false,
      warningArr: [],
      employeeList: [],
      currentDept: {},
      currentEmp: {},
      messagehow: false,
      form: {},
      isSendShow: false,
      comDeptList: [],
      currentSend: {},
      sendList: [],
      newSendList: [],
      newSendArr: [],
      customerId: null,
      historyShow: false,
      messageList: []
    }
  },
  activated () {
    if (!this.isItemActivated) {
      this.cleanOption()
      this.startTime = ''
      this.endTime = ''
      this.tabIndex = 1
      this.inputValue = ''
      this.page = 1
      if (this.routeName) {
        this.cusType = this.tab[0]
      }
    }
    this.isItemActivated = true
    this.getData()
    this.getPermissions()
    this.getFilterList()
  },
  created () {
  },
  mounted () {
    this.getFilterList()
  },
  methods: {
    // 消息
    onMessage (row) {
      this.form = {}
      this.messagehow = true
      this.customerId = row.id
      this.getSend()
    },
    onHistory () {
      this.historyShow = true
      this.getHistoryMessage()
    },
    onSubmitMessage () {
      if (!this.form.content) {
        this.$message({
          type: 'warning',
          message: '请填入要发送的消息内容!'
        })
      } else {
        this.messagehow = false
        this.isSendShow = true
      }
    },
    onSubmitSend () {
      console.log(this.form)
      console.log(this.newSendList)
      let arr = []
      if (this.newSendArr.length === 0) {
        this.$message({
          type: 'warning',
          message: '请至少选择一个发送人!'
        })
      } else {
        for (var i = 0; i < this.newSendArr.length; i++) {
          let obj = {
            content: this.form.content,
            customerId: this.customerId,
            remindId: this.newSendArr[i].id,
            remindName: this.$store.state.user.name,
            remindTime: new Date(),
            remindType: 1,
            type: 9,
            relationId: this.$store.state.user.id
          }
          arr.push(obj)
        }
        this.axios.post('message/saveAll', arr).then(res => {
          if (res.data.success) {
            this.$message({
              message: '发送成功',
              type: 'success',
              offset: 400
            })
            this.isSendShow = false
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }
      // this.isSendShow = false
    },
    getSend () {
      this.axios.post('department/findAll', {companyId: this.$store.state.companyId, type: 1}).then(res => {
        if (res.data.success) {
          this.comDeptList = res.data.data[0].children
          if (this.comDeptList.length > 0) {
            this.currentSend = this.comDeptList[0]
          }
          this.getSendObject()
        }
      })
    },
    getSendObject () {
      this.axios.post('employee/list', {departmentId: this.currentSend.id, isShowSub: true, isQuit: 0}).then(res => {
        if (res.data.success) {
          this.sendList = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    onCheckDept (dept) {
      this.currentSend = dept
      this.getSendObject()
    },
    onChooseSend (item, index) {
      if (this.newSendList.length > 0) {
        var flag = false
        for (var i = 0; i < this.newSendList.length; i++) {
          if (this.newSendList[i] === item.id) {
            this.newSendList.splice(i, 1)
            this.newSendArr.splice(i, 1)
            flag = true
            return
          }
        }
        if (!flag) {
          this.newSendList.push(item.id)
          this.newSendArr.push(item)
        }
      } else {
        this.newSendList.push(item.id)
        this.newSendArr.push(item)
      }
    },
    getHistoryMessage () {
      let param = {
        customerId: this.customerId,
        remindType: 1,
        type: 9
        // isRead: 0,
        // status: 9
      }
      this.axios.post('message/list', param).then(res => {
        if (res.data.success) {
          this.messageList = res.data.data
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error'
          })
        }
      })
    },
    getPermissions () {
      this.axios.post(`${this.$store.state.API_URL_9010}/permission/getSubmitButtonStr`, {
        parent: this.routeName
      }).then(res => {
        if (res.data.success) {
          // this.customerPermission = res.data.data.split(',')
          let btn = res.data.data.split(',')
          if (btn.indexOf('showPhoto') > -1) {
            this.showTel = true
          }
          this.showBtn = []
          this.btnList.forEach((i) => {
            btn.forEach((j) => {
              if (i.label === j) {
                this.showBtn.push(i)
              }
            })
          })
          if (this.routeName === 'BudgetExamine') {
            let budget = {}
            if (this.cusType.status === 3) {
              budget = {
                name: '通过',
                budgetStatus: 1,
                icon: '/static/images/tongguo1.png',
                iconActive: '/static/images/tongguo1-bai.png'
              }
            } else if (this.cusType.status) {
              budget = {
                name: '未通过',
                budgetStatus: -1,
                icon: '/static/images/tongguo1.png',
                iconActive: '/static/images/tongguo1-bai.png'
              }
            }
            if (JSON.stringify(budget) !== '{}') {
              this.showBtn.push(budget)
            }
          }
        }
      })
    },
    switchTab (index, list) {
      this.tabIndex = index
      this.cusType = list
      this.getData()
      this.getPermissions()
    },
    httpRequestImport (e) {
      let formData = new FormData()
      formData.append('file', e.file)
      formData.append('companyId', this.$store.state.companyId)
      this.axios.post(`${this.$store.state.API_URL_9010}/customer/import`, formData, {
        headers: {
          'type': 'web_emp',
          'Content-Type': 'multipart/form-data',
          'token': this.$store.state.token
        }
      }).then(onloadRes => {
        if (onloadRes.data.success) {
          this.$message({
            message: onloadRes.data.msg,
            type: 'success'
          })
          this.getData()
        } else {
          this.$message({
            message: onloadRes.data.msg,
            type: 'error'
          })
        }
      }).catch(() => {
        this.$message.error('导入失败！')
      })
    },
    getFilterList () { // 获取筛选条件
      this.axios.post(`${this.$store.state.API_URL_9010}/param/filterList`, {
        companyId: this.$store.state.companyId
      }).then(res => {
        if (res.data.success) {
          this.filterList = res.data.data
        }
      })
    },
    onOperate (operate) {
      this.currentOperate = operate
      let customerArr = this.$refs.erpTable.getSelectEvent()
      switch (operate.label) {
        case 'addCustomer':
          this.isAdding = true
          this.customerInfo = {
            companyId: this.$store.state.companyId
          }
          break
        case 'submitDoorCustomer':
        case 'submitDoorForecast':
        case 'submitBudgetContract':
        case 'submitBudgetExamine':
        case 'submitConstructionContract':
        case 'submitProjectManager':
          this.changeProcess(operate.label)
          break
        case 'submitProjectCompleted':
          this.finishProject(operate.label)
          break
        case 'submitSalesman':
        case 'submitDesigner':
        case 'submitCm':
        case 'submitBe':
        case 'submitPm':
        case 'submitSu':
        case 'submitAs':
        case 'submitFail':
          if (customerArr.length === 0) {
            this.$message({
              message: `请先选择客户`,
              type: 'warning'
            })
          } else {
            this.submitEmployee()
          }
          break
        case 'agreeStartWork':
          if (customerArr.length === 0) {
            this.$message({
              message: `请先选择客户`,
              type: 'warning'
            })
          } else {
            this.agreeStartWork()
          }
      }
      let that = this
      let idArr = []
      let nameArr = []
      for (let i = 0; i < customerArr.length; i++) {
        idArr.push(customerArr[i].id)
        nameArr.push(customerArr[i].name)
      }
      if (customerArr.length === 0 && operate.label !== 'addCustomer') {
        this.$message({
          message: `请先选择客户`,
          type: 'warning'
        })
      } else {
        if (this.currentOperate.budgetStatus === 1) {
          this.$confirm(`确定将${nameArr.join(',')}核算同意通过审核?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.axios.post('customer/modify', {ids: idArr.join(','), budgetPass: 1}).then(res => {
              if (res.data.success) {
                that.getData()
                that.$message.success('操作成功')
                that.$refs.erpTable.setAllSelection(false)
              } else {
                that.$message({
                  message: res.data.msg,
                  type: 'error',
                  offset: 400
                })
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消' + this.currentOperate.name
            })
          })
        } else if (this.currentOperate.budgetStatus === -1) {
          this.$confirm(`确定将${nameArr.join(',')}核算不同意通过?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.axios.post('customer/modify', {ids: idArr.join(','), budgetPass: -1}).then(res => {
              if (res.data.success) {
                that.getData()
                that.$message.success('操作成功')
                that.$refs.erpTable.setAllSelection(false)
              } else {
                that.$message({
                  message: res.data.msg,
                  type: 'error',
                  offset: 400
                })
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消' + this.currentOperate.name
            })
          })
        }
      }
    },
    finishProject (label) {
      let customerArr = this.$refs.erpTable.getSelectEvent()
      let that = this
      let idArr = []
      let nameArr = []
      for (let i = 0; i < customerArr.length; i++) {
        idArr.push(customerArr[i].id)
        nameArr.push(customerArr[i].name)
      }
      if (customerArr.length === 0) {
        this.$message({
          message: `请先选择客户`,
          type: 'warning'
        })
      } else {
        if (this.currentOperate.submitProject === 1) {
          this.$confirm(`确定将${nameArr.join(',')}工程提交竣工?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.axios.post('customer/modify', {ids: idArr.join(','), isCompleted: 1}).then(res => {
              if (res.data.success) {
                that.getData()
                that.$message.success('操作成功')
                that.$refs.erpTable.setAllSelection(false)
              } else {
                that.$message({
                  message: res.data.msg,
                  type: 'error',
                  offset: 400
                })
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消' + this.currentOperate.name
            })
          })
        }
      }
    },
    agreeStartWork () {
      let customerArr = this.$refs.erpTable.getSelectEvent()
      let idArr = []
      let nameArr = []
      for (let i = 0; i < customerArr.length; i++) {
        idArr.push(customerArr[i].id)
        nameArr.push(customerArr[i].name)
      }
      let that = this
      this.$confirm(`确定将${nameArr.join(',')}核算同意开工?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.axios.post('customer/agreeStartWork', {ids: idArr.join(','), agreeStartWork: 1}).then(res => {
          if (res.data.success) {
            that.getData()
            that.$message.success('操作成功')
            that.$refs.erpTable.setAllSelection(false)
          } else {
            that.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消' + this.currentOperate.name
        })
      })
    },
    onSubmitEmployee () {
      if (this.currentEmp.id) {
        let customerArr = this.$refs.erpTable.getSelectEvent()
        let idArr = []
        for (let i = 0; i < customerArr.length; i++) {
          idArr.push(customerArr[i].id)
        }
        let params = {
          ids: idArr.join(','),
          submitKey: this.currentOperate.label,
          employeeId: this.currentEmp.id
        }
        this.axios.post('customer/submitEmployee', this.qs.stringify(params)).then(res => {
          if (res.data.success) {
            this.isEmployeeShow = false
            this.$message.success('操作成功')
            this.$refs.erpTable.setAllSelection(false)
            this.getData()
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
              offset: 400
            })
          }
        })
      } else {
        this.$message({
          message: `请选择相关人员`,
          type: 'warning'
        })
      }
    },
    onClickEmployee (emp, index) {
      emp.isChecked = !this.isChecked
      this.currentEmp = emp
      this.$set(this.employeeList, index, emp)
    },
    onClickDept (dept, index) {
      if (this.currentDept.id !== dept.id) {
        this.currentDept = dept
        this.getEmployee()
      }
    },
    submitEmployee () {
      this.currentDept = {}
      this.currentEmp = {}
      this.axios.post('assignDefine/filterList', {companyId: this.$store.state.companyId, assignKey: this.currentOperate.label}).then(res => {
        if (res.data.success) {
          this.deptList = res.data.data
          if (res.data.data.length > 0) {
            this.currentDept = res.data.data[0]
            this.getEmployee()
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    getEmployee () {
      this.axios.post('employee/list', {departmentId: this.currentDept.id, isShowSub: true, isQuit: 0}).then(res => {
        if (res.data.success) {
          this.employeeList = res.data.data
          this.isEmployeeShow = true
          if (res.data.data.length > 0) {
            this.currentEmp = res.data.data[0]
          }
        } else {
          this.$message({
            message: res.data.msg,
            type: 'error',
            offset: 400
          })
        }
      })
    },
    changeProcess (label) {
      let customerArr = this.$refs.erpTable.getSelectEvent()
      if (customerArr.length === 0) {
        this.$message({
          message: `请先选择客户`,
          type: 'warning'
        })
      } else {
        let idArr = []
        let nameArr = []
        for (let i = 0; i < customerArr.length; i++) {
          idArr.push(customerArr[i].id)
          nameArr.push(customerArr[i].name)
        }
        let that = this
        this.$confirm(`确定将${nameArr.join(',')}${this.currentOperate.name}?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.axios.post('customer/changeProcess', this.qs.stringify({ids: idArr.join(','), process: label})).then(res => {
            if (res.data.success) {
              that.getData()
              that.$message.success('操作成功')
              that.$refs.erpTable.setAllSelection(false)
            } else {
              if (label === 'submitDoorForecast' && res.data.code === -2) {
                that.warningArr = res.data.data
                that.isWarningShow = true
              } else {
                that.$message({
                  message: res.data.msg,
                  type: 'error',
                  offset: 400
                })
              }
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消' + this.currentOperate.name
          })
        })
      }
    },
    submitAdding () {
      if (!this.customerInfo.name || !this.customerInfo.telephone || !this.Utils.isPhoneNumber(this.customerInfo.telephone) || !this.customerInfo.residentialDistrict || !this.customerInfo.location) {
        this.$message.warning('请补充完整必填项！')
      } else {
        this.axios.post('customer/save', this.customerInfo).then(res => {
          if (res.data.success) {
            this.$message.success('新增成功')
            this.getData()
            this.isAdding = false
          } else {
            this.$message({
              message: res.data.msg,
              type: 'success',
              offset: 400
            })
          }
        })
      }
    },
    onCloseAdding () {
      this.isAdding = false
    },
    cleanOption () {
      this.filterStr = null
      this.getData()
      this.$refs.filtrate.onReset()
    },
    enter (a) {
      this.Index = a
      // this.classStyle = true
    },
    leave () {
      this.Index = -2
      // this.classStyle = false
    },
    filterData () { // 筛选
      this.page = 1
      this.getData()
    },
    getData () {
      let that = this
      if (!that.startTime) {
        that.startTime = ''
      }
      if (!that.endTime) {
        that.endTime = ''
      }
      let list = {
        page: that.page,
        limit: that.limit,
        companyId: that.$store.state.companyId,
        keywords: that.inputValue
      }
      if (that.filterStr) {
        list.filterStr = JSON.stringify(that.filterStr)
      }
      if (that.cusType.type) {
        list.currentProcessKey = that.cusType.nickName
      } else {
        if (that.tab[0].nickName !== 'all') {
          list.currentProcessKey = that.tab[0].nickName
        }
      }
      if (that.cusType.type === 2) {
        list.subProcess = that.cusType.status
      }
      if (that.cusType.name === '我的储备客户' || that.cusType.name === '上门预报客户') {
        list.customerManageStartTime = that.startTime
        list.customerManageEndTime = that.endTime
      }
      if (that.cusType.timeName === '上门') {
        list.doorCustomerStartTime = that.startTime
        list.doorCustomerEndTime = that.endTime
      }
      if (that.cusType.timeName === '概算') {
        list.budgetContractStartTime = that.startTime
        list.budgetContractEndTime = that.endTime
      }
      if (that.cusType.timeName === '预算') {
        list.budgetExamineStartTime = that.startTime
        list.budgetExamineEndTime = that.endTime
      }
      if (that.cusType.timeName === '合同') {
        list.constructionContractStartTime = that.startTime
        list.constructionContractEndTime = that.endTime
      }
      if (that.cusType.timeName === '工程') {
        list.projectManagerStartTime = that.startTime
        list.projectManagerEndTime = that.endTime
      }
      if (that.cusType.timeName === '售后') {
        list.asStartTime = that.startTime
        list.asEndTime = that.endTime
      }
      this.axios.post(`${this.$store.state.API_URL_9010}/customer/queryForPage`, list).then(res => {
        if (res.data.success) {
          res.data.data.list.forEach(i => {
            if (i.telephone === 'null') {
              i.telephone = null
            }
          })
          this.tableData = res.data.data.list
          this.pageSize = res.data.data.pages
          this.pageNo = this.page
          this.pageTotal = res.data.data.size
          this.total = res.data.data.total
          this.loading = false
        }
      })
    },
    changeTitle () {
    },
    searchBtn () {
      this.page = 1
      this.loading = true
      this.getData()
    },
    toFiltrate () {
      this.$refs.filtrate.filtrateVisible = true
    },
    onDetail (row) {
      this.detailList = row
      this.detailShow = true
    },
    onManage (row) {
      this.$router.push({name: 'CustomerManagement', query: {id: row.id, parent: this.parent}})
    },
    jump (page) { // 分页
      this.page = page
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
  .left-top {
    display: flex;
    align-items: center;
    padding: 0 10px 0 20px;
    border-bottom: 1px solid #e2e2e2;
    height: 40px;
    text-align: left;
    cursor: pointer;
  }
  .dialog-left-top {
    height: 40px;
    border-bottom: 1px solid #e2e2e2;
    line-height: 40px;
    padding: 0 20px;
    font-size: 16px;
    color: #30313a;
    text-align: left;
    background-color: #ffffff;
  }
  .dialog-menu-item {
    height: 35px;
    line-height: 35px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    font-size: 12px;
    color: #30313a;
    text-align: left;
    cursor: pointer;
    &.active {
      color: #f5971d;
    }
    &.current {
      color: #f5971d;
      background: #f3f4f7;
    }
  }
  .require-tip {
    position: absolute;
    left: -10px;
    color: #ff5555;
    top: 10px;
  }
  .app-container{
    padding: 0;
  }
  .search {
    overflow: hidden;
  }
  .search /deep/.el-input__inner{
    padding-left: 0;
    border: none;
    outline: none;
  }
  .app-container /deep/ .el-input__icon{
    color: #30313a;
  }
  /*.btn-24-bg-ff :hover{*/
  /*color: #ffffff;*/
  /*background: #f5971d;*/
  /*border: solid 1px #f5971d;*/
  /*}*/
  .unit{
    font-size: 12px;
    color: #b9b9b9;
    border: solid 1px #e2e2e2;
    border-left: 0;
    border-right: 0;
    background-color: #f3f4f7;
    padding:  0 10px;
    height: 30px;
    line-height: 30px;
  }
  .border-radius-left-0 /deep/ .el-input__inner{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;

  }
  .border-radius-right-0 /deep/ .el-input__inner{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .decoration-line-hui{
    width: 4px;
    height: 16px;
    background-color: #e2e2e2;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/customer/components/Item.vue